import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import MaryImmaculateSchool from "../images/Mary Immaculate School Alumni Association.jpg";
import gurupurnima from "../images/GURU PURNIMA_ENGLISH Final.jpg";
import misaawithshibajisir from "../images/misaa with Shibaji Sir.jpg";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


function Misaa() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray" />
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Mary Immaculate School Alumni Association</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 style={{ color: "#736f6fff" }} className='misaa'>  Developing the Official Website of MISAA – An Honour and Responsibility
                                </h1>
                                <p className='websitedevelopment mb-2' style={{ color: "grey" }}>I am deeply honoured to have been entrusted with the development of the official website of <b>Mary Immaculate School Alumni Association (MISAA),</b> <a href='https://misaa.org.in/' target="_blank" rel="noopener noreferrer">https://www.misaa.org.in/</a> located at <b>96 K.K. Banerjee Road, Gorabazar, Berhampore.</b> This responsibility was given to me by <b>Mr. Arijit Gupta </b>with great trust, for which I am sincerely grateful. </p>


                                <p className='websitedevelopment' style={{ color: "grey" }}><small>It has been a pleasure working with the respected members of the association, including <b>Assistant Secretary Mr. Arijit Gupta, Secretary Mr. Sanjoy Sarkar, Mr. Shibaji Sarkar, and Mr. Sayan Chaki (Social Initiatives, Communication & Media). </b>Their unwavering support and encouragement have been invaluable to me. Beyond the professional aspect, the warmth and appreciation I have received from them hold great significance in my life.</small></p>
                            </div>
                            <div className="col-md-5">
                                <img className="card-img-top" src={MaryImmaculateSchool} alt="MaryImmaculateSchool" />

                            </div>
                        </div>
                        <br />
                        <h6 className='websitedevelopment mb-2' style={{ color: "grey" }}>I have been associated with <b>MISAA</b> for over a year now, and I hold the association and its members in the highest regard. I always strive to show respect to all my clients and genuinely wish for their continued growth and success.</h6>

                        <h5 style={{ color: "grey" }} className='linetext websitedevelopment'>I was also cordially invited to attend the <b> Annual Get-Together Re-Union 2024,</b> and it was a delightful and memorable evening. It was a true pleasure to engage with everyone and be part of such a joyous occasion.</h5>

                        <br />
                        <h6><b>Team MR. INDIAN CODER</b></h6>
                    </div>
                </div>

                <br />

                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 mt-3">
                                <Zoom>
                                    <img className="card-img-top" src={gurupurnima} alt="gurupurnima" />
                                </Zoom>
                            </div>
                            <div className="col-md-4 mt-3">
                                <Zoom>
                                    <img className="card-img-top" src={misaawithshibajisir} alt="misaawithshibajisir" />
                                </Zoom>
                            </div>

                        </div>
                    </div>
                </div>
                <br />
            </div>


        </div>
    )
}

export default Misaa